/*
 * @Description:
 * @Author: xz
 * @Date: 2023-06-16 14:07:59
 * @LastEditTime: 2024-01-04 09:30:32
 * @LastEditors: xz
 */
import Vue from 'vue'
import Router from 'vue-router'
import Earth3D from '@/components/Earth3D'
// import search from '@/components/search'
import search from '@/views/Search/search.vue'
import de from '@/components/de'
//import onebook from '@/components/onebook'
import tupu from '@/views/Tupu/tupu.vue'
import left from '@/views/Tupu/comp/tupu_left.vue'
import wordCom from '@/components/wordCom'
import Main from '@/views/Home/main.vue'
import login from '@/components/login'
import loginReport from '@/components/loginReport'
import sign from '@/components/sign'

// import Float from "@/components/Float";
import Float from '@/views/Flotage/index.vue'
import flowcount from "@/components/flowcount";
import yonghu from "@/components/yonghu";
import Report from "@/components/rebort";
import neo4j from "@/components/neo4j";
import file from "@/views/File/index";
import dataSource from "@/components/dataSource/dataSource";
import Layout from '@/components/Layout'
import ReportNew from '@/views/Reports/template.vue'
import ReportNew1 from '@/views/Reports/template1.vue'
// import addTemplate from '@/views/Reports/addTemplate.vue'
import planList from '@/views/Reports/planList.vue'
import planList1 from '@/views/Reports/planList1.vue'
import PlanBuild from '@/views/Reports/PlanBuild.vue'
import PlanBuild1 from '@/views/Reports/PlanBuild1.vue'

Vue.use(Router)

const router = new Router({
    routes: [{
        path: '/',
        name: 'main',
        component: Layout,
        children: [{
            path: "/",
            component: Main,
            name: "main",
        }]
    }, {
        path: '/search',
        name: 'search',
        // component: search
        component: Layout,
        children: [{
            path: "/search",
            component: search,
            name: "search",
        }]
    },
    {
        path: '/de',
        name: 'de',
        // component: de
        component: Layout,
        children: [{
            path: "/de",
            component: de,
            name: "de",
        }]
    },
    {
        path: '/left',
        name: 'left',
        // component: de
        component: Layout,
        children: [{
            path: "/left",
            component: left,
            name: "left",
        }]
    },
    /*{
        path: '/onebook',
        name: 'onebook',
        component: onebook
    },*/
    {
        path: '/tupu',
        name: 'tupu',
        // component: tupu
        component: Layout,
        children: [{
            path: "/tupu",
            component: tupu,
            name: "tupu",
        }]
    }, {
        path: '/wordCom',
        name: 'wordCom',
        // component: wordCom
        component: Layout,
        children: [{
            path: "/wordCom",
            component: wordCom,
            name: "wordCom",
        }]
    }, {
        path: '/Earth3D',
        name: 'Earth3D',
        // component: Earth3D
        component: Layout,
        children: [{
            path: "/Earth3D",
            component: Earth3D,
            name: "Earth3D",
        }]
    }, {
        path: '/login',
        name: 'login',
        component: login
    }, {
        path: '/loginReport',
        name: 'loginReport',
        component: loginReport
    }, {
        path: '/sign',
        name: 'sign',
        component: sign
    }, {
        path: '/Float',
        name: 'Float',
        // component: Float
        component: Layout,
        children: [{
            path: "/Float",
            component: Float,
            name: "Float",
        }]
    }, {
        path: '/Report',
        name: 'Report',
        // component: Report
        component: Layout,
        children: [{
            path: "/Report",
            component: Report,
            name: "Report",
        }]
    }, {
        path: '/yonghu',
        name: 'yonghu',
        // component: yonghu,
        component: Layout,
        children: [{
            path: "/yonghu",
            component: yonghu,
            name: "yonghu",
        }]
    }, {
        path: '/flowcount',
        name: 'flowcount',
        // component: flowcount,
        component: Layout,
        children: [{
            path: "/flowcount",
            component: flowcount,
            name: "flowcount",
        }]
    }, {
        path: '/neo4j',
        name: 'neo4j',
        // component: neo4j,
        component: Layout,
        children: [{
            path: "/neo4j",
            component: neo4j,
            name: "neo4j",
        }]
    }, {
        path: '/file',
        name: 'file',
        // component: file,
        component: Layout,
        children: [{
            path: "/file",
            component: file,
            name: "file",
        }]
    }, {
        path: '/dataSource',
        name: 'dataSource',
        // component: file,
        component: Layout,
        children: [{
            path: "/dataSource",
            component: dataSource,
            name: "dataSource",
        }]
    }, {
        path: "/planListW",
        name: "planListW",
        component: Layout,
        children: [
            {
              path: "/planListW",
              name: "planListW",
              component: planList1
            }
        ]
    }, {
        path: "/planList",
        name: "planList",
        component: planList,
        // component: Layout,
        // children: [
        //     {
        //       path: "/planList",
        //       name: "planList",
        //       component: planList
        //     }
        // ]
    }, {
        path: '/ReportNew',
        name: 'ReportNew',
        component: ReportNew
        // component: Layout,
        // children: [{
        //     path: "/ReportNew",
        //     component: ReportNew,
        //     name: "ReportNew",
        // }]
    }, {
        path: '/ReportNewW',
        name: 'ReportNewW',
        component: Layout,
        children: [{
            path: "/ReportNewW",
            component: ReportNew1,
            name: "ReportNewW",
        }]
    }, {
        path: '/PlanBuild',
        name: 'PlanBuild',
        component: PlanBuild
        // component: Layout,
        // children: [{
        //     path: "/PlanBuild",
        //     component: PlanBuild,
        //     name: "PlanBuild",
        // }]
    }, {
        path: '/PlanBuildW',
        name: 'PlanBuildW',
        // component: Report
        component: Layout,
        children: [{
            path: "/PlanBuildW",
            component: PlanBuild1,
            name: "PlanBuildW",
        }]
    }
    ]
})
router.beforeEach((to, form, next) => {
    let token = sessionStorage.getItem("token");
    console.log("to111111111", to);
    if (token) {
        next();
    } else {
        if(to.path == '/loginReport' || to.path == "/left"){
            next()
        }else if (to.path != '/login') {
            if (to.path == '/sign'||to.path == '/reportNew'||to.path == '/PlanBuild'||to.path == '/planList'){
                next()
            }else{
                next("/login");
            }

        }else {
            next()
        }

    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js